import React from 'react'
import { thankyouIcon } from '../assets/images'
import { useNavigate } from 'react-router-dom';

export default function PaymentReceived() {
  const navigate = useNavigate();
  return (
    <div className="customContainer thankyouPage payment-received">
      <div className="thankyouDetails text-center">
        <div className="form-group">
          <img src={thankyouIcon} alt="" className="thankyouIcon" />
        </div>
        <h2>Payment Already Received!</h2>
        <p style={{ fontWeight: "300" }}>
          Your payment was successful! You can now continue using EEMA
        </p>
        <div>
          <button
            onClick={() => {navigate("/", { replace: true })}}
            className="btn btn-primary"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  )
}
